import React from 'react'
import { QuestionBox } from './QuestionBox'
import { useParams } from 'react-router-dom';

export default function DynamicQuestionSet({
  questions,
  onSelectionChange,
  onReport,
  selectedOptions,
  setSelectedOptions,
  setQuestions,
  setSelectedArray,
  selectedArray,
  andId,
  setAndId,
  selectedData
}) {
  const handleSelect = (id) => {
    const updatedQuestions = questions.map(q =>
      q.id === id ? { ...q, selected: !q.selected, isAnd: selectedOptions[0], isOr: selectedOptions[1] } : q
    )

    const data = updatedQuestions.find(q => q.id === id)

    if (selectedArray?.some((item) => item?.id == data?.id)) {
      setSelectedArray(
        selectedArray?.filter((item) => item?.id != data?.id),
      );
    } else {
      setSelectedArray([
        ...selectedArray,
        {
          ...data,
          isAnd: selectedOptions[0],
          isOr: selectedOptions[1],
          andId: selectedOptions[0] ? andId + 1 : 0,
        },
      ]);
      if (selectedOptions[0]) {
        setAndId(andId + 1);
      } else {
        setAndId(0);
      }
    }

    if (selectedOptions[1]) {
      setSelectedOptions([false, false])
    }
    setQuestions(updatedQuestions)
    onSelectionChange(updatedQuestions.filter(q => q.selected), id)
  }

  return (
    <div className=" mx-auto py-4">
      {questions.map(question => (
        <QuestionBox
          key={question.id}
          question={question}
          onSelect={handleSelect}
          onReport={onReport}
          selectedData={selectedData}
        />
      ))}
    </div>
  )
}
